import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorsComponent } from '../components/modals/errors/errors.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(private modalService: NgbModal) {}

  public showError(error: any, defaultMessage: string): void {
    const modalRef = this.modalService.open(ErrorsComponent, {
      backdrop: 'static',
      windowClass: 'error-modal-background',
    });
    modalRef.componentInstance.error = error;
    modalRef.componentInstance.defaultMessage = defaultMessage;
  }
}
